<template>
  <div v-if="show" :class="$style.modal">
    <div :class="$style.content">
      <slot name="icon" :class="$style.slot_icon"></slot>
      <div v-if="icon" :class="$style.icon">
        <img :src="require(`@/assets/icons/${icon}`)" />
      </div>
      <h1 :class="$style.title" v-if="title">{{title}}</h1>
      <span :class="$style.description" v-if="description" v-html="description"></span>
      <slot name="description" :class="$style.description"></slot>
      <slot />
      <div v-if="steps" :class="$style.steps">
        <div :class="$style.step" v-for="(step, index) in steps" :key="step">
          <span :class="$style.step__number">{{index+1}}</span>
          <span :class="$style.step__description">{{step}}</span>
        </div>
      </div>
      <div v-if="showPoints" :class="$style.points">
        <span :class="$style.points__title">Ты набрал</span>
        <span :class="$style.points__number">{{points}}</span>
        <span :class="$style.points__measure">Баллов</span>
      </div>
      <div :class="$style.buttons">
        <button v-if="!hideButton || showCertificate" :class="$style.closeButton" @click="buttonClick">{{buttonText}}</button>
        <button v-if="showShare || showPoints" :class="[$style.closeButton, $style.shareButton]" @click="shareButtonClick">Поделиться <template v-if="$mq !== 'sm'">в</template> VK</button>
        <slot name="additionalBtn"></slot>
      </div>
      <div v-if="showCertificateLink"  :class="$style.certificate">
        <a href="#" @click.prevent="$emit('getCertificate')" target="_blank">
          <img src="@/assets/certificate.svg"/>
          <span>Получить сертификат</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'LevelPopup',
  props: {
    title: String,
    description: String,
    btnText: String,
    icon: String,
    steps: Array,
    showPoints: Boolean,
    hideButton: Boolean,
    showShare: Boolean,
    numberOfPoints: Number,
    showCertificate: Boolean,
    showCertificateLink: Boolean,
  },
  data: () => ({
    show: true,
  }),
  computed: {
    buttonText() {
      if (this.btnText) return this.btnText

      if (this.showCertificate) return 'Получить сертификат'

      return (this.showPoints || this.showShare) ? 'Продолжить' : 'Начать'
    },
    points() {
      return this.numberOfPoints < 10 ? `0${this.numberOfPoints}` : this.numberOfPoints
    },
  },
  methods: {
    buttonClick() {
      this.show = false
      this.$emit('close')
    },
    shareButtonClick() {
      this.$emit('share')
    },
  },
}
</script>
<style lang="scss" module>
  @import './LevelPopup.scss';
</style>
